import { guardClient } from '../_axios'

/**
 * タスク削除
 * [delete]/tasks/{id}
 */
export type DeleteTaskRequest = {
  id: string
}

export const deleteTask = async (request: DeleteTaskRequest) => {
  const { id } = request
  const path = '/tasks'
  const response = await guardClient.delete(path + '/' + id)
  return response.data
}
